import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { Report } from 'features/reports/report.types';
import { useCacheState } from 'state/useCacheState';
import { AxiosResponse } from 'axios';

const fetchReports = (
  geoEventId: number,
  cacheBusterTs: number | null,
): Promise<AxiosResponse<Report[]>> => {
  let baseUrl = `reports/?geo_event_id=${geoEventId}&status=approved&has_lat_lng=true`;
  if (cacheBusterTs) {
    baseUrl += `&ts=${cacheBusterTs}`;
  }
  return API.get<Report[]>(baseUrl);
};

export const useReportsQuery = (
  selectedGeoEventId?: number,
): UseQueryResult<AxiosResponse<Report[]> | undefined> => {
  const { cacheBusterTs } = useCacheState();

  const query = useQuery({
    queryKey: ['reports', selectedGeoEventId, cacheBusterTs],
    queryFn: () => fetchReports(selectedGeoEventId as number, cacheBusterTs),
    enabled: Boolean(selectedGeoEventId),
  });

  return query;
};
